const store = {
    namespaced: true,
    state: {
    },
};
export default store;
